import axiosInstance from '../axiosInterceptor/axiosInstance'

const addSeason = async (data) => {
  const url = `v1/orgs/${data.orgId}/seasons`
  const formData = new FormData()

  formData.append('name', data.name)
  formData.append('orgId', data.orgId)
  formData.append('startDate', data.startDate?.toISOString())
  formData.append('endDate', data.endDate?.toISOString())

  if (data.logoDataUri) {
    formData.append('logoDataUri', data.logoDataUri)
  }

  if (data.statsMode) {
    formData.append('statsMode', data.statsMode)
  }

  if (data.competitionId) {
    formData.append('competitionId', data.competitionId)
  }

  const response = await axiosInstance.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response
}

export default addSeason
